import { SendKbDeflectionClickParameters } from 'core_main/api/assistant/types';
import { sendKbDeflectionClickApiCall } from 'core_main/api/assistant';
import { PublicCallback } from 'globals/types';

export const sendKbDeflectionClick = (
  parameters: SendKbDeflectionClickParameters,
  cb?: PublicCallback,
) => {
  return sendKbDeflectionClickApiCall(parameters).then(cb);
};
